import React, { useState, useEffect } from "react";
import { navigate, usePath } from "raviger";
import { SlideDown } from "react-slidedown";
import "./SidebarSection.scoped.scss";
import useSiteStructure from "core/custom-hooks/useSiteStructure";
import useStore from "core/custom-hooks/useStore";
import clsx from "clsx";
import { setIsMobileMenuOpen } from "core/store/actionCreators";
import * as TagManager from "core/common/seo/tagManager";
import { openPopup } from "components/Popup/Popup";
import CustomerPopNotActive from "components/Popup/PopupNotActive";

const SidebarSection = ({
    svgIconName,
    title,
    navigateTo,
    sub,
    action,
    condition,
    isMobileMenu,
    disabled,
    tagManagerDetails,
    dataElemntKey,
    noNavigate,
    autoOpen,
    id,       
    isBusissnessNotActive
}) => {
    const currentPath = '/' + (usePath().split('/')[1] || '');
    const { dispatch, state } = useStore();
    const { T } = state;
    const { getPageNavigation, isEqualSub } = useSiteStructure();
    const hasSubMenus = sub && Array.isArray(sub) && sub.length;

    const isInsideOfParentMenu =
        hasSubMenus && sub.some((x) => x.navigateTo === currentPath);
    const parentMenu = isInsideOfParentMenu && getPageNavigation(currentPath);

    const [icon, setIcon] = useState("");
    const [loading, setLoading] = useState(false);
    const [shouldShowSubMenus, setShouldShowSubMenus] = useState(
        isEqualSub(parentMenu, sub)
    );

    useEffect(() => {
        if (currentPath === '/') return;
    
        let shouldRedirect = false;
    
        if (disabled && currentPath === navigateTo) {
            shouldRedirect = true;
        }
    
        if (!shouldRedirect && hasSubMenus) {
            const currentSubMenu = sub.find(x => x.navigateTo === currentPath);
            if (currentSubMenu && currentSubMenu.disabled) {
                shouldRedirect = true;
                if (isBusissnessNotActive) {
                    openCustomerNotActivePopup();
                }
            }
        }
    
        if (shouldRedirect) {
            navigate('/home');
        }
    }, [currentPath, disabled, sub, isBusissnessNotActive]);

    useEffect(() => {

        const run = async () => {
            if (autoOpen) {
                setShouldShowSubMenus(true);
            }

            setLoading(true);
            try {
                let importedIcon = await import(`assets/images/${svgIconName}.svg`);
                setIcon(importedIcon.default);
            } finally {
                setLoading(false);
            }
        }

        run()

    }, [svgIconName]);

    const pushTagManager = () => {
        //tag manager check and push data
        const subTagManager = !sub
            ? undefined
            : sub
                .map((x) =>
                    x.tagManagerDetails &&
                        (window.event?.target?.tagName?.toLowerCase() === "a" &&
                            x.dataElemntKey ==
                            window.event.target.attributes["data-elemnt-key"].value)
                        ? x.tagManagerDetails
                        : undefined
                )
                .find((x) => x); //return object and undefined in array then intersect undefined from array

        if (tagManagerDetails || subTagManager) {
            const tagManagerData = subTagManager ? subTagManager : tagManagerDetails;
            //if has subcategories and parent elemnt
            if (hasSubMenus && !subTagManager) {
                const openCloseClick = shouldShowSubMenus ? "close" : "open";
                tagManagerData.label = openCloseClick;
            }
            TagManager.sendGoogleEvent({
                category: tagManagerData.category,
                action: tagManagerData.action,
                label: tagManagerData.label,
            });
        }
        //
    };

    const handleClick = (navigateTo, action, handleSubMenus, event) => {

        if (isBusissnessNotActive) {
            openCustomerNotActivePopup();
        }
        event?.preventDefault();
        event?.stopPropagation();

        pushTagManager();

        if (handleSubMenus && hasSubMenus) {
            return setShouldShowSubMenus(!shouldShowSubMenus);
        }
        if (typeof navigateTo === "string") {
            if (isMobileMenu) {
                dispatch(setIsMobileMenuOpen(false));
            }

            if (!noNavigate) return navigate(navigateTo);
        }
        typeof action === "function" && action();
    };

    const openCustomerNotActivePopup = (type) => {      
        openPopup(dispatch, <CustomerPopNotActive type={type} />);
    };



    if (condition !== undefined && !condition) {
        return null;
    }

    return (
        <li
            id={id}
            onClick={() => {
                !disabled && handleClick(navigateTo, action, true);
            }}
            className={clsx(
                !isMobileMenu &&
                !hasSubMenus &&
                currentPath === navigateTo &&
                "selected active",
                isInsideOfParentMenu && "active",
                disabled && "disabled"
            )}
        >
            <small
                className={clsx(
                    isMobileMenu &&
                    !hasSubMenus &&
                    currentPath === navigateTo &&
                    "selected"
                )}
            >
                <span>{!loading && !!icon && <img src={icon} alt="" />}</span>
                <a
                    data-elemnt-key={dataElemntKey}
                    href={disabled || !navigateTo ? "/" : navigateTo}
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                    className={clsx(disabled && "disabled")}
                >
                    {title}
                </a>
                {/* {disabled && <span className="category-not-active">בקרוב</span>} */}
                {hasSubMenus && (
                    <i
                        id={id && `${id}-sub-arrow`}
                        className={clsx(
                            "fa",
                            "fa-chevron-down",
                            "rotate_180_0",
                            shouldShowSubMenus && "rotate_180_180"
                        )}
                    />
                )}
            </small>
            {hasSubMenus && (
                <SlideDown className="my-dropdown-slidedown" transitionOnAppear={false}>
                    {shouldShowSubMenus && (
                        <ul>
                            {sub.map((x, index) => {
                                const { title, navigateTo, action, dataElemntKey, id,disabled } = x;
                                return (
                                    <li
                                        id={id}
                                        key={index}
                                        onClick={() => {
                                            !disabled && handleClick(navigateTo, action, true);

                                        }}
                                        className={clsx(currentPath === navigateTo && "selected" ,
                                            disabled && "disabled"
                                          )}>
                                            
                                        <a
                                            data-elemnt-key={dataElemntKey}
                                            href={disabled || !navigateTo ? "/" : navigateTo}                                           
                                            onClick={(e) => {
                                                   if (disabled) {
                                                    e.preventDefault();  
                                                    e.stopPropagation(); 
                                                    return;              
                                                }
                                                else{
                                                    handleClick(navigateTo, action, false, e);
                                                }
                                            }}
                                            className={clsx(currentPath === navigateTo && "selected",
                                                disabled && "disabled"
                                            )}
                                        >
                                            <i className="fa fa-circle-o" />
                                            {title}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </SlideDown>
            )}
        </li>
    );
};

export default SidebarSection;
